import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import upgradePlanTokens from "screens/Settings/MyPlan/UpgradePlan.tokens";

const t = upgradePlanTokens;

/**
 * Line icons traced from the "Choose your plan" design so stroke weight and
 * geometry match it exactly (`@mui/icons-material` ships filled glyphs at a
 * different optical weight). Sizes and stroke widths come from the screen
 * tokens — never inline them here.
 */
interface StrokeIconProps extends SvgIconProps {
  /** Rendered box in px. */
  iconSize: number;
  /** Stroke weight in user units of the 24×24 viewBox. */
  iconStroke: number;
}

const StrokeIcon: React.FC<StrokeIconProps> = ({
  iconSize,
  iconStroke,
  children,
  sx,
  ...rest
}) => (
  <SvgIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={iconStroke}
    strokeLinecap="round"
    strokeLinejoin="round"
    sx={{
      width: iconSize,
      height: iconSize,
      flexShrink: 0,
      // SvgIcon's own styles set `fill: currentColor`, which would beat the
      // `fill="none"` attribute and flood these outline glyphs.
      fill: "none",
      ...sx,
    }}
    {...rest}
  >
    {children}
  </SvgIcon>
);

/** Back arrow next to "Back to plan summary". */
export const BackArrowIcon: React.FC<SvgIconProps> = (props) => (
  <StrokeIcon
    iconSize={t.size.backIcon}
    iconStroke={t.size.backIconStroke}
    {...props}
  >
    <path d="M19 12H5" />
    <path d="M12 19l-7-7 7-7" />
  </StrokeIcon>
);

/** Check mark in front of every plan feature. */
export const FeatureCheckIcon: React.FC<SvgIconProps> = (props) => (
  <StrokeIcon
    iconSize={t.size.bulletIcon}
    iconStroke={t.size.bulletIconStroke}
    {...props}
  >
    <path d="M20 6L9 17l-5-5" />
  </StrokeIcon>
);

/** "Opens in a new tab" glyph on the compare-plans link. */
export const ExternalLinkIcon: React.FC<SvgIconProps> = (props) => (
  <StrokeIcon
    iconSize={t.size.compareIcon}
    iconStroke={t.size.compareIconStroke}
    {...props}
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <path d="M15 3h6v6" />
    <path d="M10 14L21 3" />
  </StrokeIcon>
);
